import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationModalComponent } from '../components/notification-modal/notification-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private dialog: MatDialog) { }

  showSuccess(message: string, title: string = '¡Éxito!', callback?: () => void) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '400px',
      data: {
        type: 'success',
        title: title,
        message: message
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'modal-backdrop'
    });

    if (callback) {
      dialogRef.afterClosed().subscribe(() => {
        callback();
      });
    }
  }

  showError(message: string, title: string = 'Error') {
    this.dialog.open(NotificationModalComponent, {
      width: '400px',
      data: {
        type: 'error',
        title: title,
        message: message
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'modal-backdrop'
    });
  }

  showConfirm(message: string, title: string = 'Confirmación') {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '400px',
      data: {
        type: 'confirm',
        title: title,
        message: message
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'modal-backdrop'
    });

    return dialogRef.afterClosed();
  }

  showCondolences(callback?: () => void) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '400px',
      data: {
        type: 'condolences',
        title: 'Nuestras Condolencias',
        message: 'En esta circunstancia, te ofrecemos nuestras más profundas condolencias y nuestro apoyo.<br><br>Estamos para apoyarte las 24 horas en caso de cualquier duda.<br><br>Es importante mantenerse al pendiente del teléfono ya que en unos minutos uno de nuestros ejecutivos se pondrá en contacto contigo vía telefónica para el seguimiento a tu solicitud.'
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'modal-backdrop'
    });

    if (callback) {
      dialogRef.afterClosed().subscribe(() => {
        callback();
      });
    }
  }

  isFuneralService(serviceType: string): boolean {
    return serviceType === 'Funeraria' || serviceType === 'Asistencia Legal Funeraria';
  }
}